import createHistory from 'history/createBrowserHistory';

const { PUBLIC_URL } = process.env; // The value set in the homepage property of package.json is exposed in the process.env.PUBLIC_URL variable at build time.
const history = createHistory({ basename: PUBLIC_URL });

export default history;



// WEBPACK FOOTER //
// ./src/history.js